// Simple i18n translation file for French and English
// Usage: import { t, setLanguage } from './i18n';

let currentLang = localStorage.getItem('lang') || 'fr';

const translations = {
  fr: {
    siteTitle: 'Réparez, détournez, réutilisez : donnez une seconde vie à vos objets',
    siteCatchPhrase: "Découvrez et partagez des idées concrètes pour réparer, détourner et réutiliser vos objets du quotidien",
    searchObjectTitle: "Je veux réparer ou transformer un objet",
    searchPlaceholder: 'Chaise cassée, bouteille plastique, t-shirt troué',
    searchButton: 'Trouver des solutions',
    suggestionBottle: 'Bouteille en plastique',
    suggestionVinyle: 'Vinyle',
    suggestionGuitare: 'Guitare',
    projectTitle: "Je veux partager une création",
    projectButton: 'Partager ma création',
    noResults: 'Aucun résultat',
    rescuedObjectsTitle: 'Objets transformés : découvrez leurs nouvelles vies',
    objectsTitle: 'Objets réparables, détournables, réutilisables',
    projectsTitle: 'Créations DIY d\'objets réparés, détournés, réutilisés ou transformés',
    exploreMenu: 'Projets',
    categoriesMenu: 'Objets',
    howItWorksTitle: 'Comment ça marche ?',
    howItWorksStep1: "Trouvez un objet (cassé ou inutile)",
    howItWorksStep2: 'Découvrez des idées proposées par la communauté',
    howItWorksStep3: 'Partagez votre propre transformation',
    statsObjects: 'objets réutilisés',
    statsProjects: 'créations partagées',
    statsUsers: 'contributeurs',
    filterByObject: 'Filtrer par objet',
    filterByCategory: 'Filtrer par catégorie :',
    allCategories: 'Toutes les catégories',
    noProjectForObject : "Aucun projet trouvé pour cet objet.",
    noObjectFound: "Aucun objet trouvé.",
    searchObjectPlaceholder: 'Chaise cassée, bouteille plastique, t-shirt troué',
    allObjects: 'Tous les objets',
    loginTitle: 'Se connecter',
    usernameLabel: "Nom d'utilisateur",
    passwordLabel: 'Mot de passe',
    noAccount: 'Pas encore de compte ?',
    createAccount: 'Créer un compte',
    loginButton: 'Se connecter',
    newsletterTitle: 'Recevez des idées concrètes pour transformer vos objets',
    newsletterPlaceholder: 'Votre adresse email',
    newsletterButton: "Recevoir les idées",
    close: 'Fermer',
    privacyTitle: 'Politique de confidentialité',
    privacyIntro: 'Nous attachons une grande importance à votre vie privée. Cette page explique comment nous collectons, utilisons et protégeons vos données personnelles conformément au RGPD.',
    privacyWhatData: 'Quelles données nous collectons',
    privacyEmail: "Adresse e-mail (uniquement si vous vous abonnez à la newsletter ou créez un compte)",
    privacyHowUse: 'Comment nous utilisons vos données',
    privacyUseNewsletter: 'Pour vous envoyer la newsletter si vous êtes abonné',
    privacyUseAccount: 'Pour créer et gérer votre compte si vous vous inscrivez',
    privacyNoShare: 'Nous ne partageons pas votre e-mail avec des tiers',
    privacyRights: 'Vos droits',
    privacyRightAccess: 'Vous pouvez demander l’accès ou la suppression de vos données à tout moment',
    privacyRightUnsub: 'Vous pouvez vous désabonner de la newsletter à tout moment',
    privacyConsent: 'Consentement',
    privacyConsentText: 'Nous ne collectons votre e-mail qu’avec votre consentement explicite. En vous abonnant ou en créant un compte, vous acceptez cette politique.',
    privacyContact: 'Contact',
    privacyContactText: 'Pour toute question ou demande concernant vos données, contactez-nous à :',
    allRightsReserved: 'Tous droits réservés.',
  },
  en: {
    siteTitle: 'Repair, Repurpose, Reuse: Give Your Objects a Second Life',
    siteCatchPhrase: 'Discover and share concrete ideas to repair, repurpose, and reuse your everyday objects',
    searchObjectTitle: 'I have an object to save',
    searchPlaceholder: 'Broken chair, plastic bottle, torn t-shirt',
    searchButton: 'Find solutions',
    suggestionBottle: 'Plastic bottle',
    suggestionVinyle: 'Vinyl',
    suggestionGuitare: 'Guitar',
    projectTitle: 'I want to share a creation',
    projectButton: 'Share my creation',
    noResults: 'No results',
    rescuedObjectsTitle: 'Transformed objects: discover their new lives',
    objectsTitle: 'Objects to save',
    projectsTitle: 'DIY creations of repaired, repurposed, reused, or transformed objects',
    exploreMenu: 'Projects',
    categoriesMenu: 'Objects',
    howItWorksTitle: 'How does it work?',
    howItWorksStep1: 'Find an object (broken or unused)',
    howItWorksStep2: 'Discover ideas shared by the community',
    howItWorksStep3: 'Share your own transformation',
    statsObjects: 'objects saved',
    statsProjects: 'ideas shared',
    statsUsers: 'contributors',
    filterByObject: 'Filter by object',
    filterByCategory: 'Filter by category:',
    allCategories: 'All categories',
    searchObjectPlaceholder: 'Broken chair, plastic bottle, torn t-shirt',
    allObjects: 'All objects',
    loginTitle: 'Log in',
    usernameLabel: 'Username',
    passwordLabel: 'Password',
    noAccount: 'No account yet?',
    createAccount: 'Create an account',
    loginButton: 'Log in',
    newsletterTitle: 'Receive concrete ideas to transform your objects',
    newsletterPlaceholder: 'Your email address',
    newsletterButton: 'Receive ideas',
    close: 'Close',
    privacyTitle: 'Privacy Policy',
    privacyIntro: 'We value your privacy. This page explains how we collect, use, and protect your personal data in accordance with the General Data Protection Regulation (GDPR).',
    privacyWhatData: 'What Data We Collect',
    privacyEmail: 'Email address (only if you subscribe to our newsletter or create an account)',
    privacyHowUse: 'How We Use Your Data',
    privacyUseNewsletter: 'To send you newsletters if you have subscribed',
    privacyUseAccount: 'To create and manage your account if you register',
    privacyNoShare: 'We do not share your email with third parties',
    privacyRights: 'Your Rights',
    privacyRightAccess: 'You can request access to or deletion of your data at any time',
    privacyRightUnsub: 'You can unsubscribe from the newsletter at any time',
    privacyConsent: 'Consent',
    privacyConsentText: 'We only collect your email with your explicit consent. By subscribing or creating an account, you agree to this policy.',
    privacyContact: 'Contact',
    privacyContactText: 'For any questions or requests regarding your data, please contact us at:',
    allRightsReserved: 'All rights reserved.',
  },
};

export function t(key) {
  // If the translation exists in the current language, use it
  if (translations[currentLang] && translations[currentLang][key]) {
    return translations[currentLang][key];
  }
  // Otherwise, fallback to French if available
  if (translations['fr'] && translations['fr'][key]) {
    return translations['fr'][key];
  }

  // Otherwise, fallback to the key
  return key;
}

export function setLanguage(lang) {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem('lang', lang);
  }
}



export function getLanguage() {
  return currentLang;
}
